// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Szbn","dot":"_3Ha7P","tooltip-content":"_3Jysx","tooltipContent":"_3Jysx"};